export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}competency/requirement/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        userSuitability: {
            method: 'GET',
            isArray: true,
            url: `${url}/user-suitability`
        },
        updateCompetence: {
            method: 'POST',
            url: `${url}/update-competence`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/CompetenceRequirement/index.js